import { Component, effect, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { QuestionAnswer, Questionnaire } from 'src/app/modal/questionnaire.models';
import { ProductService } from 'src/app/services/product.service';

@Component({
    selector: 'optional-coverage',
    templateUrl: './optional-coverage.component.html',
    styleUrls: ['./optional-coverage.component.css']
})
export class OptionalCoverageComponent implements OnInit {

    @Input() questionnaire: Questionnaire;
    @Input() isFormSubmitted: boolean;
    @Input() umBiLimitQuestionBehaviore: BehaviorSubject<QuestionAnswer>;
    @Input() uimBiQuestionBehaviore: BehaviorSubject<QuestionAnswer>;

    public hiredAutoLiability: QuestionAnswer;
    public annualCostOfHire: QuestionAnswer;
    public hiredAutoUimBi: QuestionAnswer;
    public hiredAutoUmBi: QuestionAnswer;
    public minimumAnnualCostOfHire: number = 5000;
    public uimBi: QuestionAnswer;
    public umBi: QuestionAnswer;
    public nonOwnedAutoLiability: QuestionAnswer;
    public nonOwnedAutoLiabEmployeesCount: QuestionAnswer;
    public nonOwnedAutoUmBi: QuestionAnswer;
    public nonOwnedAutoUimBi: QuestionAnswer;
    public disableAutoLiability: Boolean = false;
    public trailerShipments: QuestionAnswer;

    constructor(private productService : ProductService) { this.onTrailerShipmentChanged(); }

    onTrailerShipmentChanged(){
        effect(() => {
            const trailerQA = this.productService.trailerShipmentSignal();
            if(!!trailerQA){ 
                this.disableAutoLiability = trailerQA === 'Yes';  
                this.hiredAutoLiability.answer = trailerQA; 
                this.nonOwnedAutoLiability.answer = trailerQA; 
                this.resetHiredAutoLiability();
                this.resetNonOwnedAutoLiability();
            }else{
                this.disableAutoLiability = this.trailerShipments.answer == 'Yes';
            }   
        });
    }

    public ngOnInit(): void {
        this.loadQuestionAnswers();      
        this.umBiLimitQuestionBehaviore.subscribe(question => {
            if (!!question && this.hiredAutoUmBi.enabled) {
                // this.hiredAutoUmBi.hidden means the control is disabled but visible - State (LA)
                if (this.hiredAutoUmBi.hidden) 
                    this.hiredAutoUmBi.answer = question.answer;
                else 
                    this.resetHiredAutoUmBianswer();
                
            }
            if (!!question && this.nonOwnedAutoUmBi.enabled) {
                // this.nonOwnedAutoUmBi.hidden means the control is disabled but visible - State (LA)
                if (this.nonOwnedAutoUmBi.hidden) 
                    this.nonOwnedAutoUmBi.answer = question.answer;
                else 
                    this.resetNonownedAutoUmBianswer();
            }
        });
        this.uimBiQuestionBehaviore.subscribe(question => {
            if (!!question && this.hiredAutoUimBi.enabled && this.hiredAutoUimBi.hidden) {
                if (this.hasSelection(question)) {
                    this.hiredAutoUimBi.answer = question.answer;
                }
            }
            if (!!question && this.nonOwnedAutoUimBi.enabled && this.nonOwnedAutoUimBi.hidden) {
                if (this.hasSelection(question)) {
                    this.nonOwnedAutoUimBi.answer = question.answer;
                }
            }
        });        
    }

    private hasSelection(question: QuestionAnswer): boolean {
        return !!question?.answer && question?.answer !== 'CLICK';
    }

    private loadQuestionAnswers(): void {
        var defaultQuestionAnswer = this.getDefaultQuestionAnswer();
        this.hiredAutoLiability = this.LoadAnswerFromDefault('hiredAutoLiability');
        this.annualCostOfHire = this.LoadAnswerFromDefault('annualCostOfHire');
        this.hiredAutoUimBi = this.LoadAnswerFromDefault('hiredAutoUimBi');
        this.hiredAutoUmBi = this.LoadAnswerFromDefault('hiredAutoUmBi');
        this.nonOwnedAutoLiability = this.LoadAnswerFromDefault('nonOwnedAutoLiability');
        this.nonOwnedAutoLiabEmployeesCount = this.LoadAnswerFromDefault('nonOwnedAutoLiabEmployeesCount');
        this.nonOwnedAutoUmBi = this.LoadAnswerFromDefault('nonOwnedAutoUmBi');
        this.nonOwnedAutoUimBi = this.LoadAnswerFromDefault('nonOwnedAutoUimBi');

        this.uimBi = this.questionnaire.questionAnswer.find(x => x.key === 'uimBi') ?? defaultQuestionAnswer;
        this.umBi = this.questionnaire.questionAnswer.find(x => x.key === 'umBiLimit') ?? defaultQuestionAnswer;
        if (this.questionnaire.questionAnswer.some(x => x.key === 'hiredAutoUimBi') && this.hiredAutoUimBi.questionOptions.length == 0)
            this.hiredAutoUimBi.questionOptions = this.questionnaire.questionAnswer.find(x => x.key === 'uimBi').questionOptions;
        if (this.questionnaire.questionAnswer.some(x => x.key === 'hiredAutoUmBi') && this.hiredAutoUmBi.questionOptions.length == 0)
            this.hiredAutoUmBi.questionOptions = this.questionnaire.questionAnswer.find(x => x.key === 'umBiLimit').questionOptions;
        if (this.questionnaire.questionAnswer.some(x => x.key === 'nonOwnedAutoUimBi') && this.nonOwnedAutoUimBi.questionOptions.length == 0)
            this.nonOwnedAutoUimBi.questionOptions = this.questionnaire.questionAnswer.find(x => x.key === 'uimBi').questionOptions;
        if (this.questionnaire.questionAnswer.some(x => x.key === 'nonOwnedAutoUmBi') && this.nonOwnedAutoUmBi.questionOptions.length == 0)
            this.nonOwnedAutoUmBi.questionOptions = this.questionnaire.questionAnswer.find(x => x.key === 'umBiLimit').questionOptions;
        this.trailerShipments = this.LoadAnswerFromDefault('trailerShipments');
    }

    private get filterHiredOrNonOwnedAutosUmBiOptions(){
        // Filter out DECLINE options and keep only up to selected limit
        let options = this.umBi.questionOptions.filter(option => !option.code.startsWith("DECLINE"));
        const selectedAnswer = this.umBi.answer;
        const isSlashSelection = selectedAnswer?.includes('/');

        // If this.umBi.answer has a slash option selected (e.g 100,000/300,000): then Hired Or NonOwnedAutos UmBi Options shall show only slash options up to selected
        // If this.umBi.answer has a single option selected (200,000): then Hired Or NonOwnedAutos UmBi Options shall show only single (non-slash) options up to selected
        options = options.filter(option => isSlashSelection ? option.code.includes('/') : !option.code.includes('/'));

        const matchIndex = options.findIndex(option => option.code === selectedAnswer);
            if (matchIndex >= 0) {
                options = options.slice(0, matchIndex + 1);
            }
        return options;
    }

    private resetHiredAutoUmBianswer(): void {
        if (this.umBi.answer === 'DECLINE') {
            // Remove DECLINE options from the list and set the filtered options to hiredAutoUmBi
            this.hiredAutoUmBi.questionOptions = this.umBi.questionOptions.filter(option => !option.code.startsWith("DECLINE"));
        }
        else if (this.hasSelection(this.umBi)) {
	        this.hiredAutoUmBi.questionOptions = this.filterHiredOrNonOwnedAutosUmBiOptions;
            this.hiredAutoUmBi.answer = this.umBi.answer;
        }
        else {
            // Even if User select UmBi limit or not, if hiredAutoLiability.answer == 'Yes' and
            // if hiredAutoUmBi.enabled and not hiredAutoUmBi.hidden user must select option hiredAutoUmBi option without Decline option
            this.hiredAutoUmBi.questionOptions = this.umBi.questionOptions.filter(option => !option.code.startsWith("DECLINE"));
        }
    }

    public resetHiredAutoLiability(): void {
        if (this.hiredAutoLiability.answer == 'No') {
            this.annualCostOfHire.answer = '';
        }
        else {
            if (this.hiredAutoUimBi.enabled) {
                this.hiredAutoUimBi.answer = this.uimBi.answer;
            }
            if (this.hiredAutoUmBi.enabled) {
                this.resetHiredAutoUmBianswer();
            }
        }
    }

    private resetNonownedAutoUmBianswer(): void {
        if (this.umBi.answer === 'DECLINE') {
            // Remove DECLINE options from the list and set the filtered options to nonOwnedAutoUmBi
            this.nonOwnedAutoUmBi.questionOptions = this.umBi.questionOptions.filter(option => !option.code.startsWith("DECLINE"));
        }
        else if (this.hasSelection(this.umBi)) {
	        this.nonOwnedAutoUmBi.questionOptions = this.filterHiredOrNonOwnedAutosUmBiOptions;
            this.nonOwnedAutoUmBi.answer = this.umBi.answer;
        }
        else {
            // Even if User select UmBi limit or not, if hiredAutoLiability.answer == 'Yes' and
            // if nonOwnedAutoUmBi.enabled and not nonOwnedAutoUmBi.hidden user must select option nonOwnedAutoUmBi option without Decline option
            this.nonOwnedAutoUmBi.questionOptions = this.umBi.questionOptions.filter(option => !option.code.startsWith("DECLINE"));
        }
    }

    public resetNonOwnedAutoLiability(): void {
        if (this.nonOwnedAutoLiability.answer == 'No') {
            this.nonOwnedAutoLiabEmployeesCount.answer = '';
        }
        else {
            if (this.nonOwnedAutoUimBi.enabled) {
                this.nonOwnedAutoUimBi.answer = this.uimBi.answer;
            }
            if (this.nonOwnedAutoUmBi.enabled) {
                this.resetNonownedAutoUmBianswer();
            }
        }
    }

    public LoadAnswerFromDefault(key: string): QuestionAnswer {
        var defaultQuestionAnswer = this.getDefaultQuestionAnswer();
        let questionAnswer = this.questionnaire.questionAnswer.find(x => x.key === key) ?? defaultQuestionAnswer;
        if (!!!questionAnswer?.answer && questionAnswer?.questionDefault?.length > 0) {
            questionAnswer.answer = questionAnswer.questionDefault[0].code;
        }
       else if (!!!questionAnswer?.answer && questionAnswer?.questionDefault?.length == 0 
              && questionAnswer?.questionOptions[0]?.code.startsWith("CLICK")) 
        {
            questionAnswer.answer = questionAnswer?.questionOptions[0]?.code;
        }
        return questionAnswer;
    }

    private getDefaultQuestionAnswer(): QuestionAnswer {
        return {
            answer: null,
            enabled: false,
            required: false,
            group: null,
            hidden: false,
            key: null,
            isVehicleUpdatedbyVEH1: false,
            minimum: null,
            name: null,
            type: '',
            rowIndex: 0,
            questionOptions: []
        }
    }
}
